export default {
  createFirmware: 'Publish new firmware',
  updateFirmware: 'Device firmware update',
  lotManagement: 'Lot management',
  createFirmwareFormTitle: 'Publish firmware',
  deviceAssignment: 'Device assignment',
};
